import { render, staticRenderFns } from "./menu-down.vue?vue&type=template&id=91df13ec"
import script from "./menu-down.vue?vue&type=script&lang=js"
export * from "./menu-down.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports